import React from "react";
import { Link } from "react-router-dom";
import { Plus } from "lucide-react";
import { useCart } from "@/context/CartContext";
import { WINE_COLORS } from "@/data/wines";
import { toast } from "sonner";

const WineCard = ({ wine }) => {
  const { addItem } = useCart();
  const colorMeta = WINE_COLORS[wine.color];

  const handleAdd = (e) => {
    e.preventDefault();
    e.stopPropagation();
    addItem(wine, 1);
    toast.success(`${wine.name} ajouté au panier`, {
      description: `${wine.price.toFixed(2)}€ · ${colorMeta.label}`,
    });
  };

  return (
    <Link
      to={`/vin/${wine.id}`}
      data-testid={`wine-card-${wine.id}`}
      className="group relative flex flex-col bg-white border border-[#E8E2D2] hover:border-[#5B2333]/40 transition-all duration-300 hover:-translate-y-1 hover:shadow-[0_18px_40px_-22px_rgba(91,35,51,0.45)]"
    >
      {/* Bottle photo area — uniform white background matching the card body */}
      <div className="relative w-full h-64 sm:h-72 lg:h-80 bg-white flex items-center justify-center p-4 sm:p-5 overflow-hidden">
        <img
          src={wine.image}
          alt={wine.name}
          loading="lazy"
          className="block max-h-full max-w-full w-auto h-auto object-contain drop-shadow-[0_12px_18px_rgba(91,35,51,0.22)] group-hover:scale-[1.03] transition-transform duration-500"
        />
      </div>

      <div className="flex-1 flex flex-col items-center text-center px-3 sm:px-5 pt-4 pb-3 sm:pb-4 gap-1">
        <h3 className="font-heading text-sm sm:text-base lg:text-lg uppercase tracking-[0.1em] text-[#1A1617] leading-snug line-clamp-2 min-h-[2.5em]">
          {wine.name}
        </h3>
        <p className="text-[10px] sm:text-xs tracking-[0.15em] uppercase text-[#5C5651]">
          {wine.region}
        </p>
        <p className="text-[9px] sm:text-[10px] tracking-[0.2em] uppercase text-[#C5A059] font-semibold">
          {wine.producer}
        </p>

        <p
          data-testid={`wine-price-${wine.id}`}
          className="font-heading text-xl sm:text-2xl text-[#1A1617] mt-2"
        >
          {wine.price.toFixed(2)} €
        </p>

        <button
          type="button"
          onClick={handleAdd}
          data-testid={`add-to-cart-${wine.id}`}
          aria-label={`Ajouter ${wine.name} au panier`}
          className="mt-3 w-9 h-9 flex items-center justify-center bg-[#5B2333] text-white hover:bg-[#4A1525] transition-all active:scale-95"
        >
          <Plus className="w-4 h-4" strokeWidth={2.2} />
        </button>
      </div>
    </Link>
  );
};

export default WineCard;
